import { compareWeeks } from './compare-weeks';

export function checkCurrentWeek(dateEpoch: number): boolean {
  const today = new Date();
  const comparedDate = new Date(dateEpoch);

  return compareWeeks(today, comparedDate);
}
